var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keyan"},[_c('Banner',{attrs:{"banner":_vm.banner}}),_c('TypeMenu',{staticClass:"type",attrs:{"menu":_vm.type}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.component,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }